import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const IdentifiesRomanticallyStyles = styled(OnboardingPage)``;
